import { useTagging } from "@/hooks/mutations/use-tag";
import { useMappingStore } from "@/stores/mapping";
import { useCallback, useLayoutEffect, useRef } from "react";
import { MemberViewType } from "./types";
import { toTagInfo } from "./util";

type TaggingToast = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useTagClick = ({ toast }: { toast?: TaggingToast } = {}) => {
  const dimension = useMappingStore((state) => state.dimension.dimension);
  const { handleClick } = useTagging({ toast });
  const handleClickRef = useRef(handleClick);
  const dimensionRef = useRef(dimension);

  useLayoutEffect(() => {
    handleClickRef.current = handleClick;
    dimensionRef.current = dimension;
  }, [handleClick, dimension]);

  return useCallback((tag: MemberViewType) => {
    const tagInfo = toTagInfo(tag, dimensionRef.current);

    void handleClickRef.current(tagInfo, tag.isSelected)();
  }, []);
};
